<div class="title-container">
  <span class="title" [matTooltip]="filename"
    >{{ route ? route + ': ' : '' }}{{ filename }}</span
  >
  <span *ngIf="!completed" class="state">{{
    started ? 'processing' : 'waiting'
  }}</span>
  <mat-icon *ngIf="completed" class="complete" (click)="clickComplete()"
    >done</mat-icon
  >
</div>
<ng-container
  ><mat-progress-bar
    color="primary"
    [value]="completed ? 100 : progress"
    [mode]="
      completed ? 'determinate' : started ? 'indeterminate' : 'query'
    "></mat-progress-bar
></ng-container>
